import { DialogProps } from "@mui/material"

/**
 * Возвращает onClose-обработчик для MUI Dialog, который игнорирует закрытие
 * по клику вне окна (backdropClick) и по Escape. Закрытие возможно только через
 * явные элементы (крест/кнопка), вызывающие `onClose` напрямую.
 */
export const blockBackdropClose =
  (onClose: () => void): DialogProps["onClose"] =>
  (_event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") return
    onClose()
  }
